<template>
  <div class="nettdoc-gynecological-issues">
    <SectionHeader 
      text="I have gynecological issues" 
      img="illu-card-beschwerden-gynecological" 
      alt="gynecological issues" 
      :collapsable="true" 
      v-on:collapse="collapsed = !collapsed"
      :complete="store.gynecologicalIssuesDetails.submitted"
    />

    <template v-if="collapsed">
      <SectionHeader text="Since when do you experience the discomfort?" :dark="true" :required="true" />
      <Dropdown
        label="please choose"
        :data="['A few hours', '1 day', '2 to 6 days', 'More than one week', '1 Month']"
        :choice="store.gynecologicalIssuesDetails.since"
        v-on:action="value => store.addGynecologicalIssuesDetails('since', value)"
      />

      <SectionHeader text="difficultiesDefecating" :dark="true" :required="true" />
      <YesNo
        :model="store.gynecologicalIssuesDetails.difficultiesDefecating"
        v-on:action="value => store.addGynecologicalIssuesDetails('difficultiesDefecating', value)"
      />

      <SectionHeader text="difficultiesUrinating" :dark="true" :required="true" />
      <YesNo
        :model="store.gynecologicalIssuesDetails.difficultiesUrinating"
        v-on:action="value => store.addGynecologicalIssuesDetails('difficultiesUrinating', value)"
      />

      <template v-if="store.gynecologicalIssuesDetails.difficultiesUrinating === 'yes'">
        <SectionHeader text="difficultiesUrinatingBurningPerception" :dark="true" :required="false" />
        <YesNo
          :model="store.gynecologicalIssuesDetails.difficultiesUrinatingBurningPerception"
          v-on:action="value => store.addGynecologicalIssuesDetails('difficultiesUrinatingBurningPerception', value)"
        />

        <SectionHeader text="difficultiesUrinatingNotPossible" :dark="true" :required="false" />
        <YesNo
          :model="store.gynecologicalIssuesDetails.difficultiesUrinatingNotPossible"
          v-on:action="value => store.addGynecologicalIssuesDetails('difficultiesUrinatingNotPossible', value)"
        />

        <SectionHeader text="difficultiesUrinatingBloodyUrine" :dark="true" :required="false" />
        <TripleChoice
          :model="store.gynecologicalIssuesDetails.difficultiesUrinatingBloodyUrine"
          v-on:action="value => store.addGynecologicalIssuesDetails('difficultiesUrinatingBloodyUrine', value)"
        />
      </template>

      <SectionHeader text="generalMenstruationDisorder" :dark="true" :required="false" />
      <YesNo
        :model="store.gynecologicalIssuesDetails.generalMenstruationDisorder"
        v-on:action="value => store.addGynecologicalIssuesDetails('generalMenstruationDisorder', value)"
      />

      <SectionHeader text="menstruationWithPain" :dark="true" :required="false" />
      <YesNo
        :model="store.gynecologicalIssuesDetails.menstruationWithPain"
        v-on:action="value => store.addGynecologicalIssuesDetails('menstruationWithPain', value)"
      />

      <SectionHeader text="problemsBreastFeeding" :dark="true" :required="false" />
      <YesNo
        :model="store.gynecologicalIssuesDetails.problemsBreastFeeding"
        v-on:action="value => store.addGynecologicalIssuesDetails('problemsBreastFeeding', value)"
      />

      <SectionHeader text="painDuringCoitus" :dark="true" :required="false" />
      <YesNo
        :model="store.gynecologicalIssuesDetails.painDuringCoitus"
        v-on:action="value => store.addGynecologicalIssuesDetails('painDuringCoitus', value)"
      />

      <SectionHeader text="breastPain" :dark="true" :required="false" />
      <YesNo
        :model="store.gynecologicalIssuesDetails.breastPain"
        v-on:action="value => store.addGynecologicalIssuesDetails('breastPain', value)"
      />

      <SectionHeader text="breastNodes" :dark="true" :required="false" />
      <YesNo
        :model="store.gynecologicalIssuesDetails.breastNodes"
        v-on:action="value => store.addGynecologicalIssuesDetails('breastNodes', value)"
      />

      <SectionHeader text="nippleEfflux" :dark="true" :required="false" />
      <YesNo
        :model="store.gynecologicalIssuesDetails.nippleEfflux"
        v-on:action="value => store.addGynecologicalIssuesDetails('nippleEfflux', value)"
      />

      <SectionHeader text="vaginalEfflux" :dark="true" :required="false" />
      <YesNo
        :model="store.gynecologicalIssuesDetails.vaginalEfflux"
        v-on:action="value => store.addGynecologicalIssuesDetails('vaginalEfflux', value)"
      />

      <template v-if="store.gynecologicalIssuesDetails.vaginalEfflux === 'yes'">
        <SectionHeader text="vaginalEffluxType" :dark="true" :required="true" />
        <CheckboxList 
          :data="['yellow', 'bloody', 'Smelling bad']"
          :choice="store.gynecologicalIssuesDetails.vaginalEffluxType"
          v-on:action="value => store.addGynecologicalIssuesDetails('vaginalEffluxType', value, true)"          
        />
      </template>

      <SectionHeader text="firstDayOfMonthlyMenstruation" :dark="true" :required="true" />
      <Dropdown
        label="please choose"
        :data="['today', '1 to 5 days', 'Within the last three weeks', 'More than 1 month ago', 'More than 6 months ago', 'Never']"
        :choice="store.gynecologicalIssuesDetails.firstDayOfMonthlyMenstruation"
        v-on:action="value => store.addGynecologicalIssuesDetails('firstDayOfMonthlyMenstruation', value)"
      />

      <SectionHeader text="vaginalItchiness" :dark="true" :required="false" />
      <YesNo
        :model="store.gynecologicalIssuesDetails.vaginalItchiness"
        v-on:action="value => store.addGynecologicalIssuesDetails('vaginalItchiness', value)"
      />

      <SectionHeader text="menopause" :dark="true" :required="false" />
      <TripleChoice
        :model="store.gynecologicalIssuesDetails.menopause"
        v-on:action="value => store.addGynecologicalIssuesDetails('menopause', value)"
      />

      <SectionHeader text="passedMenopause" :dark="true" :required="false" />
      <TripleChoice
        :model="store.gynecologicalIssuesDetails.passedMenopause"
        v-on:action="value => store.addGynecologicalIssuesDetails('passedMenopause', value)"
      />

      <SectionHeader text="possiblePregnancy" :dark="true" :required="false" />
      <TripleChoice
        :model="store.gynecologicalIssuesDetails.possiblePregnancy"
        v-on:action="value => store.addGynecologicalIssuesDetails('possiblePregnancy', value)"
      />

      <SectionHeader text="sexFrequently" :dark="true" :required="false" />
      <YesNo
        :model="store.gynecologicalIssuesDetails.sexFrequently"
        v-on:action="value => store.addGynecologicalIssuesDetails('sexFrequently', value)"
      />

      <SectionHeader text="neverHadSex" :dark="true" :required="false" />
      <YesNo
        :model="store.gynecologicalIssuesDetails.neverHadSex"
        v-on:action="value => store.addGynecologicalIssuesDetails('neverHadSex', value)"
      />

      <SectionHeader text="protection" :dark="true" :required="false" />
      <YesNo
        :model="store.gynecologicalIssuesDetails.protection"
        v-on:action="value => store.addGynecologicalIssuesDetails('protection', value)"
      />

      <template v-if="store.gynecologicalIssuesDetails.protection === 'yes'">
        <CheckboxList 
          :data="['Hormonal (birth control pill)', 'condoms']"
          :choice="store.gynecologicalIssuesDetails.protectionType"
          v-on:action="value => store.addGynecologicalIssuesDetails('protectionType', value, true)"          
        />
      </template>

      <SectionHeader text="frequentMenstruationCycle" :dark="true" :required="false" />
      <YesNo
        :model="store.gynecologicalIssuesDetails.frequentMenstruationCycle"
        v-on:action="value => store.addGynecologicalIssuesDetails('frequentMenstruationCycle', value)"
      />

      <SectionHeader text="pregnantBefore" :dark="true" :required="false" />
      <TripleChoice
        :model="store.gynecologicalIssuesDetails.pregnantBefore"
        v-on:action="value => store.addGynecologicalIssuesDetails('pregnantBefore', value)"
      />

      <SectionHeader text="children" :dark="true" :required="false" />
      <YesNo
        :model="store.gynecologicalIssuesDetails.children"
        v-on:action="value => store.addGynecologicalIssuesDetails('children', value)"
      />

      <template v-if="store.gynecologicalIssuesDetails.children === 'yes'">
        <SectionHeader text="childrenCount" :required="false" :dark="true" />
        <NumberInput
          label="Children"
          :showLabel="true"
          :model="store.gynecologicalIssuesDetails.childrenCount"
          v-on:action="value => store.addGynecologicalIssuesDetails('childrenCount', value)"
        />
      </template>

      <SectionHeader text="birthComplications" :dark="true" :required="false" />
      <YesNo
        :model="store.gynecologicalIssuesDetails.birthComplications"
        v-on:action="value => store.addGynecologicalIssuesDetails('birthComplications', value)"
      />

      <SectionHeader text="abortion" :dark="true" :required="false" />
      <YesNo
        :model="store.gynecologicalIssuesDetails.abortion"
        v-on:action="value => store.addGynecologicalIssuesDetails('abortion', value)"
      />

      <SectionHeader text="lostChildToComplications" :dark="true" :required="false" />
      <YesNo
        :model="store.gynecologicalIssuesDetails.lostChildToComplications"
        v-on:action="value => store.addGynecologicalIssuesDetails('lostChildToComplications', value)"
      />

      <SectionHeader text="birthType" :dark="true" :required="false" />
      <CheckboxList 
        :data="['normal', 'Surgical operation']"
        :choice="store.gynecologicalIssuesDetails.birthType"
        v-on:action="value => store.addGynecologicalIssuesDetails('birthType', value, true)"          
      />

      <SectionHeader text="childrenAges" :dark="true" :required="false" />
      <CheckboxList 
        :data="['Under one year', 'Between 1 and 3 years', 'More than three years']"
        :choice="store.gynecologicalIssuesDetails.childrenAges"
        v-on:action="value => store.addGynecologicalIssuesDetails('childrenAges', value, true)"          
      />

      <SectionHeader text="surgeryOn" :dark="true" :required="false" />
      <CheckboxList 
        :data="['Uterus/ womb', 'Ovary', 'Breasts', 'Intestine', 'Appendix', 'Gall bladder', 'Other abdominal organ']"
        :choice="store.gynecologicalIssuesDetails.surgeryOn"
        v-on:action="value => store.addGynecologicalIssuesDetails('surgeryOn', value, true)"          
      />

      <SectionHeader text="familyDiseases" :dark="true" :required="false" />
      <CheckboxList 
        :data="['Diabetes mellitus (Blood sugar disease)', 'High blood pressure', 'deformation']"
        :choice="store.gynecologicalIssuesDetails.familyDiseases"
        v-on:action="value => store.addGynecologicalIssuesDetails('familyDiseases', value, true)"          
      />

      <SectionHeader text="malignantDiseaseOnOrgans" :dark="true" :required="false" />
      <CheckboxList 
        :data="['Breasts', 'Uterus/ womb', 'Neck of uterus', 'Ovary', 'Intestine', 'Other organs', 'Thrombosis', 'Pulmonary embolism', 'Blood coagulation disorder']"
        :choice="store.gynecologicalIssuesDetails.malignantDiseaseOnOrgans"
        v-on:action="value => store.addGynecologicalIssuesDetails('malignantDiseaseOnOrgans', value, true)"          
      />

      <SectionHeader text="lastGynecologicalVisit" :dark="true" :required="false" />
      <Dropdown
        label="please choose"
        :data="['Never', 'In the last year', 'In the last 5 years', 'More than 5 years']"
        :choice="store.gynecologicalIssuesDetails.lastGynecologicalVisit"
        v-on:action="value => store.addGynecologicalIssuesDetails('lastGynecologicalVisit', value)"
      />

      <Button :text="edit ? 'Update' : 'Submit'" v-on:action="submit" :active="store.gynecologicalIssuesDetailsComplete" />
    </template>
  </div>
</template>

<script>
import { observer } from "mobx-vue";

import SectionHeader from "../SectionHeader"
import YesNo from "../YesNo"
import Button from "../Button"
import Dropdown from "../Dropdown"
import CheckboxList from '../CheckboxList'
import TripleChoice from '../TripleChoice'
import NumberInput from '../NumberInput'
export default observer({
  name: "GynecologicalIssues",
  data() {
    return {
      collapsed: true
    };
  },
  props: {
    store: Object,
    edit: Boolean
  },
  components: {
    SectionHeader, YesNo, Button, Dropdown, CheckboxList, TripleChoice, NumberInput
  },
  methods: {
    submit: function() {
      this.store.gynecologicalIssuesDetails.submitted = true
      localStorage.setItem(
        "gynecologicalIssuesDetails",
        JSON.stringify(this.store.gynecologicalIssuesDetails)
      )
      if (this.edit) {
        this.$emit('close')
      } else {
        this.collapsed = !this.collapsed
        window.scrollTo(0,0)
      }
    }
  }
})
</script>

<style>

</style>